module.exports = __webpack_public_path__ + "static/img/sarah.a4bdc01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/sarah.jpg
// module id = 213
// module chunks = 1